import { useProperty, useTranslation } from '@eti/providers';
import { useRef } from 'react';
import { useLinksAccessibility } from '../../../custom-hooks/useLinkAccessibility';
import ProductLayout from '../../../common/main-layout/ProductLayout';
import { wrapperStyles } from '../../common/styles';
import { useIllustration } from '../../../common/utils/useIllustration';
import { useProductSnowplowTracking } from '../../../custom-hooks/useProductSnowplowTracking';
import { getProduct } from '../../../single-choice/utils/singleChoiceTransformer';
import { getModal, getPriceProps, getReadMoreLabel, getSingleChoiceProps, getUpsellProps } from '../../../common/utils/productCardProps';
import { TRAVEL_INSURANCE_OUTSIDE_EU } from '../../../products';
import getTranslatedTexts from '../../../common/text-resolvers/utils/getTranslatedTexts';
import TaxIdInput from '../../common/components/TaxIdInput';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = TRAVEL_INSURANCE_OUTSIDE_EU;
export const texts = {
  persuasionContent: 'travelInsuranceOutsideEUPersuasionContent',
  confirmationContent: 'travelInsuranceOutsideEUConfirmationContent',
  confirmText: 'travelInsuranceOutsideEUConfirmationYes',
  declineText: 'travelInsuranceOutsideEUConfirmationNo',
  upSell: 'travelInsuranceOutsideEUUpSellText',
  additionalInformation: 'travelInsuranceOutsideEUAdditionalInformation',
  readMoreContent: 'travelInsuranceOutsideEUReadMoreModalContent',
  abstractSectionContent: 'travelInsuranceOutsideEUAbstract',
  title: 'travelInsuranceOutsideEUTitle'
};
const MainTravelInsuranceOutsideEu = _ref => {
  var _order$persuasion$isE, _order$persuasion;
  let {
    className,
    form,
    order,
    productPosition,
    isSelected,
    sellSpecification,
    recoverSessionTaxId
  } = _ref;
  const {
    t,
    nonDebugT
  } = useTranslation();
  const {
    p
  } = useProperty();
  const illustrationUrl = useIllustration(PRODUCT_NAME);
  const rootElement = useRef(null);
  const {
    abstractSectionContent: description,
    additionalInformation,
    confirmationContent = '',
    confirmText = '',
    declineText = '',
    persuasionContent = '',
    readMoreContent,
    title,
    upSell
  } = getTranslatedTexts(texts, t);
  useProductSnowplowTracking(PRODUCT_NAME, {
    productPosition,
    rootElement
  });
  useLinksAccessibility({
    targetElement: rootElement,
    productTitle: title
  });
  const product = getProduct(PRODUCT_ID, order, 'traveler');
  if (!product) {
    return null;
  }
  const {
    priceRaw
  } = product;
  const readMoreButtonLabel = getReadMoreLabel(t);
  const {
    priceLabel,
    price,
    priceSuffix
  } = getPriceProps(t, isSelected, product);
  const shouldShowTaxIdInput = p('TravelerDetails.TaxIdFeature.Enabled') && isSelected;
  const productCardModal = getModal((_order$persuasion$isE = (_order$persuasion = order.persuasion) === null || _order$persuasion === void 0 ? void 0 : _order$persuasion.isEnabled) !== null && _order$persuasion$isE !== void 0 ? _order$persuasion$isE : false, confirmationContent, persuasionContent);
  const modalText = {
    confirmText,
    declineText
  };
  const {
    upSellObject,
    isUpsellHighlight = false,
    shouldDisplayUpsell = false
  } = getUpsellProps(upSell);
  const extraProps = getSingleChoiceProps(t, p, nonDebugT);
  const productData = {
    additionalInformation,
    className,
    description,
    extraProps,
    form,
    illustrationUrl,
    isHighlighted: isUpsellHighlight,
    isSelected,
    modalText,
    price,
    priceLabel,
    priceRaw,
    priceSuffix,
    productCardModal,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    readMoreButtonLabel,
    readMoreContent,
    sellSpecification,
    shouldDisplayUpsell,
    title,
    upSell: upSellObject
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ProductLayout, {
      className: wrapperStyles(shouldShowTaxIdInput),
      productData: productData,
      ref: rootElement
    }), shouldShowTaxIdInput && /*#__PURE__*/_jsx(TaxIdInput, {
      isSelected: isSelected,
      recoverSessionTaxId: recoverSessionTaxId
    })]
  });
};
export default MainTravelInsuranceOutsideEu;
//# sourceMappingURL=MainTravelInsuranceOutsideEu.js.map